import {ch, ac, phone, three, continuity, company, psw, pEmail, departmentId} from './filters.js';
import {getJobs, getDepart, resetPwd, sendExmailByIdAccount, checkAccount, generatePsw} from '@/api/api.js';
import {sendExmailByIdAccountTwo} from "../api/api";

export default {

    provide() { // 这里定义provide 传递参数
        return {}
    },
    data() {
        let validateName = (rule, value, callback) => {
            let str = value
            str = str.replace(/[ ]/g, "")
            str = str.trim()
            if (!value) {
                return callback(new Error(this.$t('memberlist.name_r1')));
            }
            if (!ch.test(str)) {
                callback(new Error(this.$t('memberlist.name_r2')));
            } else {
                callback();
            }
        };
        let validateEmail = (rule, value, callback) => {
            let isTure = value.includes("@");
            if (!value) {
                return callback(new Error(this.$t('memberlist.google_email_error2')));
            }
            if (!isTure) {
                return callback(new Error(this.$t('memberlist.google_email_error1')));
            } else {
                callback();
            }
        };
        let validateEmail2 = (rule, value, callback) => {
            let isTure = value.includes("@");
            if (!value) {
                return callback(new Error(this.$t('memberlist.email_error2')));
            }
            if (!isTure) {
                return callback(new Error(this.$t('memberlist.email_error1')));
            } else {
                callback();
            }
        };
        let validateAccout = (rule, value, callback) => {
            let n = (value.split('.')).length - 1
            if (!value) {
                return callback(new Error(this.$t('memberlist.ac_r1')));
            }
            if (!ac.test(value) || n > 2 || n < 1) {
                callback(new Error(this.$t('memberlist.name_r3')));
            } else if (this.$route.name == 'memberList') {
                checkAccount({ account: value }).then(() => {
                    callback();
                }).catch(() => {
                    // callback(this.$t('memberlist.name_r4'));
                })

            } else {
                callback();
            }
        };
        let validateDept = (rule, value, callback) => {
            if (!value) {
                return callback(new Error(this.$t('memberlist.d_r1')));
            }
            if (!departmentId.test(parseInt(value))) {
                callback(new Error(this.$t('memberlist.d_r1')));
            } else {
                callback();
            }
        };
        // eslint-disable-next-line
        let validatePhone = (rule, value, callback) => {
            // if (!value) {
            //     return callback(new Error(this.$t('memberlist.p_r1')));
            // }else 
            if (value) {
                if (!phone.test(value) && this.userInfo.phone_code == '86') {
                    callback(new Error(this.$t('memberlist.p_r2')));
                } else if (!(/^\d+$/.test(value))) {
                    callback(new Error(this.$t('memberlist.p_r3')));
                } else {
                    callback();
                }
            } else {
                callback();
            }

        }

        // let validateIdcard = (rule, value, callback) => {

        //     if (this.userInfo.id_type == 1) {
        //         if ( !idcard.test(value) ) {
        //             callback(new Error(this.$t('memberlist.c_r1')));
        //         } else {
        //             callback();
        //         }
        //     } else {
        //         if ( !( /^[a-zA-Z0-9]{0,18}$/.test(value)) ) {
        //             callback(new Error(this.$t('memberlist.c_r2')));
        //         } else {
        //             callback();
        //         }
        //     }
        // }
        // eslint-disable-next-line
        let validateIdPersonal = (rule, value, callback) => {
            if (value) {
                if (!pEmail.test(value)) {
                    callback(new Error(this.$t('memberlist.e_r1')));
                } else if (value.length > 30) {
                    callback(new Error(this.$t('memberlist.e_r2')));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        }

        let validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('memberlist.input_pwd')));
            } else if (value.length < 12) {
                callback(new Error(this.$t('memberlist.psw_12')));
            } else if (three.test(value)) {
                callback(new Error(this.$t('memberlist.psw_r1')));
            } else if (continuity(value)) {
                callback(new Error(this.$t('memberlist.psw_r3')));
            } else if (company.test(value)) {
                callback(new Error(this.$t('memberlist.psw_r4')));
            } else if (!psw.test(value)) {
                callback(new Error(this.$t('memberlist.psw_r2')));
            } else {
                if (this.pswInfo.checkPass !== '') {
                    this.$refs.pswInfo.validateField('checkPass');
                }
                callback();
            }
        };
        let validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('memberlist.confirm_pwd')));
            } else if (value !== this.pswInfo.password) {
                callback(new Error(this.$t('memberlist.psw_match')));
            } else {
                callback();
            }
        }
        // let host = window.location.hostname;
        return {
            userInfo: {
                username: '',
                account: '',
                depart_id_beisen: '',
                job_id: '',
                entry_date: '',
                gender: 0,
                supervisor_account: '',
                creat_email: 1,
                google_email: ''
            },
            rule1: {
                username: [
                    { validator: validateName, required: true, trigger: 'blur' },
                ],
                email: [
                    { validator: validateEmail2, required: true, trigger: 'blur' },
                ],
                gg_key: [
                  { message: this.$t('memberlist.ggkey_error1'), required: true,  trigger: 'blur' },
                ],
                // account: [
                //   { validator: validateAccout, required: true,  trigger: 'blur' },
                // ],

                //   id_number: [
                //       {  validator: validateIdcard,  trigger: 'blur'  },
                //   ],
                //   email: [
                //       {  message: '请填写邮箱', required: true, trigger: 'blur'  },
                //   ],
                depart_id_beisen: [
                    { validator: validateDept, message: this.$t('memberlist.d_r1'), required: true, trigger: 'change'},
                ],
                // team_type: [
                //     {  message: this.$t('memberlist.j_r1'), required: true, trigger: 'blur'  },
                // ],
                // job_id: [
                //     { message: this.$t('memberlist.j_r1'), required: true, trigger: 'change' },
                // ],
                // personal_email: [
                //     {  validator: validateIdPersonal, trigger: 'blur'  },
                // ],
                // entry_date: [
                //     { message: this.$t('memberlist.t_r1'), required: true, trigger: 'blur' },
                // ],
            },
            rules: {
                username: [
                    { validator: validateName, required: true, trigger: 'blur' },
                ],
                account: [
                    { validator: validateAccout, required: true, trigger: 'blur' },
                ],
                // 校验邮箱
                google_email: [
                    { validator: validateEmail, required: true, trigger: 'blur' },
                ],
                // phone: [
                //     { validator: validatePhone, trigger: 'blur' },
                // ],
                //   id_number: [
                //       {  validator: validateIdcard,  trigger: 'blur'  },
                //   ],
                //   email: [
                //       {  message: '请填写邮箱', required: true, trigger: 'blur'  },
                //   ],
                depart_id_beisen: [
                    {validator: validateDept, message: this.$t('memberlist.d_r1'), required: true, trigger: 'change'},
                ],
                // team_type: [
                //     { message: this.$t('memberlist.j_r1'), required: true, trigger: 'blur' },
                // ],
                // job_id: [
                //     { message: this.$t('memberlist.j_r1'), required: true, trigger: 'change' },
                // ],
                // personal_email: [
                //     { validator: validateIdPersonal, trigger: 'blur' },
                // ],
                entry_date: [
                    { message: this.$t('memberlist.t_r1'), required: true, trigger: 'blur' },
                ],
            },
            passRules: {
                password: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
            },
            departments: [],
            jobs: [],
            random: ''
        }
    },
    computed: {
        cardType() {
            return [{ name: this.$t('memberlist.id_card'), id: 1 }, { name: this.$t('memberlist.home'), id: 3 }, { name: this.$t('memberlist.taiwan'), id: 4 }, { name: this.$t('memberlist.passport'), id: 10 }]
        },
        cardTypeshow() {
            return [this.$t('memberlist.id_card'), this.$t('memberlist.id_card'), '', this.$t('memberlist.home'), this.$t('memberlist.taiwan'), '', '', '', '', '', this.$t('memberlist.passport')]
        }
    },
    methods: {
        getArrays(datas) { //遍历树 
            let arr = datas
            for (var i in arr) {

                arr[i].children = arr[i].child_list
                if (arr[i].child_list.length) {
                    this.getArrays(arr[i].child_list);
                }
            }
            this.departments = arr
        },
        hindleChanged(val) {
            this.searchInfo.depart_id = (val[0] && val[0].id) || ''

        },
        newChanged(val) {
            this.userInfo.depart_id_beisen = val[0] && val[0].id
            this.$refs.userInfo.validateField('depart_id_beisen');
            this.$nextTick(() => {
                document.querySelector('.wl-select-tag').childNodes[0].textContent = (val[0] && val[0].name_path) || ''
            })
        },
        async jobAnddep() {
            const data = await Promise.all([getJobs(), getDepart()])
            this.jobs = data[0]
            this.getArrays(data[1])
        },
        // 确认重置
        resetSure() {

            this.$refs.pswInfo.validate((valid) => {
                if (!valid) {
                    this.$message({ message: this.$t('memberlist.jy'), type: 'warning' })
                    return false;
                } else {
                    let params = {
                        password: this.pswInfo.password,
                        account: this.userAccount
                    }
                    resetPwd(params).then(() => {
                        this.pswVisible = false
                        this.$message({ message: this.$t('memberlist.msg_reset'), type: 'success' })
                    })
                }
            });
        },
        // 重置密码取消 
        resetCancel(formName) {
            this.pswVisible = false
            this.$refs[formName].resetFields();
        },
        cancelSendMail() {
            this.sendMVisible = false
        },
        // 发送通行证信息到企业邮箱
        sendMailAction() {
            let params = {
                password: this.pswInfo.password,
                account: this.userAccount
            }
            resetPwd(params).then(() => {
                this.pswVisible = false
                this.$message({message: this.$t('memberlist.msg_reset'), type: 'success'})
            })
        },
        sendExmailByIdAccount(id, account) {
            console.log('willSendEmail: ' + id + '|' + account);
            let params = {
                id: id,
                account: account,
            }
            //console.log(params );
            //return false;
            sendExmailByIdAccount(id, params).then((res) => {
                //console.log('fetch recall url as:')
                //console.log(res, 999999)
                if (res?.url) {
                    console.log('recall to send mail')
                    sendExmailByIdAccountTwo(res?.url).then((resp) => {
                        //console.log(resp)
                        this.sendMVisible = false
                        this.$message({message: this.$t('memberlist.msg_send_email'), type: 'success'})
                    }).catch((ex) => {
                        console.log(ex)
                    })
                } else {
                    //err
                }
            }).catch(e => {
                console.log(e)
                // axios.post(postUrl,params2).then(resp=>
                // {
                //     console.log(resp);
                //     this.josarr=resp.data.jokes//数据赋值
                //
                // })
            })
        },
        passClose() {
            this.resetCancel('pswInfo')
        },
        // 获取随机密码
        getRandom() {
            generatePsw().then(res => {
                this.random = res.password
            })
        }
    },
    activated() {
        this.jobAnddep()
    }
}